module.exports = __webpack_public_path__ + "img/icon_class2.28fb4f38.png";